"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
require("./languages.scss");
const Languages = (props) => {
    return (react_1.default.createElement(core_1.Box, { id: 'languages', className: `v2-container-background ${props.className}` },
        react_1.default.createElement("h4", { className: 'v2-profile-block-heading' }, "Languages"),
        props.language.map((el, i) => react_1.default.createElement("a", { key: i, href: `#/directory/services?id=${el.lang_id}&name=${el.name}&parent_id=${el.service_id}&isLang=true`, className: "language" },
            react_1.default.createElement("p", { className: "area" }, el.name),
            react_1.default.createElement("p", { className: "text" },
                el.levelName,
                ", Certificate No: ",
                el.cert)))));
};
exports.default = Languages;
